import React from 'react';
import PropTypes from 'prop-types';
import { Schema, Field } from 'v4f';

import validateForm from '../helpers/ValidateForm';

const propTypes = {
  email: PropTypes.string,
  handleInputChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSending: PropTypes.bool.isRequired,
  name: PropTypes.string,
  selectedItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  terms: PropTypes.bool.isRequired,
  toggleTerms: PropTypes.func.isRequired,
};

const Form = ({
  email,
  handleInputChange,
  handleSubmit,
  isSending,
  name,
  selectedItems,
  terms,
  toggleTerms,
}) => {
  /* eslint-disable new-cap */
  const emailSchema = Schema({
    email: Field()
      .string()
      .email()
      .required(),
  });
  const stringSchema = Schema({
    string: Field()
      .string()
      .lengthGreater(1)
      .required(),
  });

  const isEmailValid = (data) => emailSchema.validate({ email: data });
  const isStringValid = (data) => stringSchema.validate({ string: data.trim() });

  const isFormValid = validateForm({
    email,
    name,
    terms,
  });

  const isDisabled = !isFormValid || selectedItems.length !== 1;

  return (
    <ul className="list form-list">
      <li className="field text-field">
        <label
          className="label text-label"
          htmlFor="name"
        >
          <input
            className={`input ${isStringValid(name) ? 'is-valid' : ''}`}
            id="name"
            name="name"
            onChange={handleInputChange}
            placeholder="Nimesi"
            required
            type="text"
            value={name}
          />
        </label>
      </li>
      <li className="field text-field">
        <label
          className="label text-label"
          htmlFor="email"
        >
          <input
            className={`input ${isEmailValid(email) ? 'is-valid' : ''}`}
            id="email"
            name="email"
            onChange={handleInputChange}
            placeholder="Sähköpostiosoitteesi"
            required
            type="email"
            value={email}
          />
        </label>
      </li>
      <li className="field checkbox-field">
        <label
          className="terms-wrap"
          htmlFor="terms"
        >
          <label
            htmlFor="terms"
            className="terms-checkbox-label"
          >
            <input
              aria-checked={terms}
              className="checkbox"
              checked={terms}
              type="checkbox"
              id="terms"
              name="terms"
              onChange={handleInputChange}
              required
            />
          </label>
          <span className="terms-checkbox-copy">
            <span>
              Olen lukenut ja hyväksyn&nbsp;
            </span>
            <button
              className="text-button"
              onClick={toggleTerms}
              title="Avaa säännöt"
              type="button"
            >
              arvonnan säännöt
            </button>
          </span>
        </label>
      </li>
      <li className="field submit-field">
        {isSending ? (
          <p className="sending-copy">
            <strong>Lomaketta lähetetään...</strong>
          </p>
        ) : (
          <button
            aria-describedby="missing-fields"
            className="button submit-button"
            disabled={isDisabled}
            id="send"
            onClick={handleSubmit}
            type="button"
          >
            Osallistu kilpailuun &raquo;
          </button>
        )}
        <p className="form-disclaimer">
          Käytämme yhteystietoja vain voittajien tavoittamiseen.
        </p>
      </li>
      {isDisabled ? (
        <li className="form-errors">
          <h3 className="form-errors-title">
            Ole hyvä ja täytä vielä
          </h3>
          <ul className="list form-errors-list missing-fields">
            {selectedItems.length !== 1 ? (
              <li className="error-item">
                Vastauksesi
              </li>
            ) : null}
            {!isStringValid(name) ? (
              <li className="error-item">
                Nimesi
              </li>
            ) : null}
            {!isEmailValid(email) ? (
              <li className="error-item">
                Sähköpostiosoitteesi
              </li>
            ) : null}
            {!terms ? (
              <li className="error-item">
                Säännöt luettu
              </li>
            ) : null}
          </ul>
        </li>
      ) : null}
    </ul>
  );
};

Form.propTypes = propTypes;

Form.defaultProps = {
  email: '',
  name: '',
};

export default Form;
